<template>
  <img v-bind="$attrs" :src="path" alt=""/>
</template>
<script setup lang="ts">
import { useColorMode } from '@vueuse/core';
import { computed } from 'vue';

const props = defineProps<{ src: string, darkSrc?: string }>()

const mode = useColorMode();

const path = computed(() => {
  return mode.value === 'light' ?
    props.src :
    props.darkSrc ?? props.src
})
</script>
